(function () {
  'use strict';

  angular.module('app').component('transportationDetail', transportationDetail());

  function transportationDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        activeTab: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: TransportationDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation/transportation-detail/transportation-detail.component.html',
    };
  }

  TransportationDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$location',
    '$filter',
    'ModalWindowConfirmService',
    'TransportationService',
    'TransportationScheduleService',
    'TransportationContentService',
    'MeasurementUnitService',
    'SessionService',
    'ProductCategoryService',
    'TaxService',
    'ProductService',

    // Angular downgraded service
    'companyService',
    'facilityService',
    'facilityModalService',
    'whatToBringService',
    'whatToBringModalService',
    'locationService',
    'locationModalService',
    'utilService',
  ];

  function TransportationDetailComponent(
    config,
    UtilService,
    $location,
    $filter,
    ModalWindowConfirmService,
    TransportationService,
    TransportationScheduleService,
    TransportationContentService,
    MeasurementUnitService,
    SessionService,
    ProductCategoryService,
    TaxService,
    ProductService,

    // Angular downgraded service
    companyService,
    facilityService,
    facilityModalService,
    whatToBringService,
    whatToBringModalService,
    locationService,
    locationModalService,
    utilService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    vm.showMeridian = true;
    vm.timeOptions = config.TIME_OPTIONS;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.costBasedTypes = config.COST_BASED_TYPES;

    vm.checkedFacility = {};
    vm.checkedWhatToBring = {};

    vm.productSearchId = null;

    var transportationScheduleFieldsDefinition = [
      'departure',
      'duration',
      'duration_time_unit',
      'min_pax_required',
      'max_pax_allowed',
      'cutoff',
      'cutoff_time_unit',
    ];

    // Methods
    vm.selectProductCategory = selectProductCategory;
    vm.openProductCategoriesModal = openProductCategoriesModal;

    vm.addTransportationSchedule = addTransportationSchedule;
    vm.removeTransportationSchedule = removeTransportationSchedule;
    vm.changeTransportationScheduleStatus = changeTransportationScheduleStatus;
    vm.deleteTransportationSchedule = deleteTransportationSchedule;
    vm.validateUniqueSchedules = validateUniqueSchedules;
    vm.setScheduleType = setScheduleType;

    vm.toggleEditMode = toggleEditMode;

    vm.addRoutePoint = addRoutePoint;
    vm.removeRoutePoint = removeRoutePoint;
    vm.restoreRoutePoints = restoreRoutePoints;
    vm.validateUniqueRoutePoints = validateUniqueRoutePoints;
    vm.openTransportationRoutePointsMapModal = openTransportationRoutePointsMapModal;
    vm.setRoutePointMap = setRoutePointMap;

    vm.openLocationsModal = openLocationsModal;
    // vm.compareUniquenessOfLocations = compareUniquenessOfLocations;

    vm.openFacilitiesModal = openFacilitiesModal;
    vm.openWhatToBringsModal = openWhatToBringsModal;

    vm.openTransportationContentsModal = openTransportationContentsModal;

    vm.editTransportation = editTransportation;
    vm.cancelEdit = cancelEdit;
    vm.saveTransportation = saveTransportation;
    vm.cancel = cancel;

    vm.selectAssociatedProviders = selectAssociatedProviders;
    vm.onAssociatedProviderSaved = onAssociatedProviderSaved;
    vm.onAssociatedProviderDeleted = onAssociatedProviderDeleted;
    vm.onSelectedTab = onSelectedTab;

    vm.selectAssociatedServiceItems = selectAssociatedServiceItems;
    vm.onAssociatedServiceItemSaved = onAssociatedServiceItemSaved;
    vm.onAssociatedServiceItemDeleted = onAssociatedServiceItemDeleted;
    vm.selectAccounting = selectAccounting;

    vm.selectCostsAndPrices = selectCostsAndPrices;
    vm.onCostsAndPricesSaved = onCostsAndPricesSaved;

    vm.selectAssociatedTaxes = selectAssociatedTaxes;
    vm.onAssociatedTaxesSaved = onAssociatedTaxesSaved;
    vm.onAssociatedTaxesCanceled = onAssociatedTaxesCanceled;

    // vm.updateCustomTaxConfiguration = updateCustomTaxConfiguration;
    // vm.onProductAssociatedTaxSaved  = onProductAssociatedTaxSaved;

    vm.$onInit = function () {
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.item.id) {
        // Edit
        vm.active = vm.activeTab ? parseInt(vm.activeTab) : 0;

        setItemOptions(vm.item, vm.mode);
        getServerData(vm.item);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          service_items_cost_based: null,
          company_id: SessionService.getSelectedAccountCompany().id,
          transportation_schedules: [],
          transportation_route_points: [],
        };

        // Initializers
        getLocations();
        getProductCategories('');

        addTransportationSchedule();
      }

      // Initializers
      getCompany();

      getTransportations();

      getFacilities();
      getWhatToBrings();
    };

    vm.openSearchCabys = function (item) {
      const succesCallBack = (itemObj) => {
        vm.item.cabys_code = itemObj.codigo;
        vm.item.cabys_description = itemObj.descripcion;
        vm.item.cabys_tax = itemObj.impuesto;
      };

      ProductService.openSearchCabys(item, succesCallBack);
    };

    vm.searchCabys = function () {
      if (!vm.item.cabys_code || vm.item.cabys_code.length < 13) return;

      let searchBy = 'codigo=' + vm.item.cabys_code.toLowerCase();

      vm.clearCabys();

      vm.invalidCabys = false;

      vm.searchingCabys = true;
      ProductService.searchCabys(searchBy).then(function (data) {
        if (data[0] && data[0].codigo) {
          vm.item.cabys_code = data[0].codigo;
          vm.item.cabys_description = data[0].descripcion;
          vm.item.cabys_tax = data[0].impuesto;

          vm.invalidCabys = false;
        } else {
          vm.invalidCabys = true;
        }

        vm.searchingCabys = false;
      });
    };

    vm.clearCabys = function () {
      vm.item.cabys_description = '';
      vm.item.cabys_tax = '';
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        editTransportation();
      }

      vm.productIsExempt = item.is_exempt || false;

      vm.productCategorySelected = item.product_category;
      vm.serviceItemsCostBasedEvaluated = item.service_items_cost_based ? true : false;

      setTransportationSchedules(item.transportation_schedules);
      vm.scheduleTypeOriginal = angular.copy(item.schedule_type);

      vm.item.transportation_route_points = item.transportation_route_points || [];
      vm.origDataTransportationRoutePoints = angular.copy(vm.item.transportation_route_points);

      /*if (vm.item.transportation_route_points.length){
                vm.showRoutePointsMap = true;
            }*/

      setCheckedFacilities(vm.item.facility_ids);
      setCheckedWhatToBring(vm.item.what_to_bring_ids);

      vm.customTaxConfiguration = item.custom_tax_configuration;

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data

      vm.flashMessage = vm.UtilService._displayFlashMessage();
    }

    function getServerData(item) {
      // To reload code number consecutive
      getProductCategories('');
    }

    function editTransportation() {
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getLocations();

      if (vm.item.schedule_type === 'fixed') {
        vm.item.transportation_schedules.forEach(function (schedule) {
          schedule.departure = vm.UtilService.setDurationTime(schedule.departure);
        });
      }

      setTransportationSchedules(vm.item.transportation_schedules);
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getCompany() {
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: vm.LanguageCode,
        })
        .subscribe(function (response) {
          // defaultLanguageuser
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types;
            vm.taxRateCodes = response.country.country_setting.tax_rate_codes;
          }

          vm.measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
            response.measurement_units,
            'transportation'
          );

          if (!vm.createMode) {
            vm.measurementUnit = vm.measurementUnits.find(
              (item) => item.id === vm.item.measurement_unit_id
            );
          }
        });
    }

    // ----- PRODUCT CATEGORIES ----- //

    function getProductCategories(option) {
      var params = {
        get: 'active',
        by_product_type: 'transportation',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingProductCategories = true;
      ProductCategoryService.getProductCategories(params).then(function (data) {
        vm.productCategories = data.items;
        vm.loadingProductCategories = false;

        if (option === 'update') {
          var productCategory = vm.productCategories.find(
            (item) => item.id === vm.productCategorySelected.id
          );
          vm.productCategorySelected = null;
          selectProductCategory(productCategory);
        }
      });
    }

    function selectProductCategory(productCategory) {
      if (vm.productCategorySelected && vm.productCategorySelected.id === productCategory.id) {
        // Same product category is selected
        return;
      }

      vm.productCategorySelected = productCategory;

      vm.item.code_number = '';

      // Edit mode
      if (vm.editMode) {
        // Same product category as the item
        if (vm.originalItem.product_category_id === productCategory.id) {
          vm.item.code = vm.originalItem.code;
          vm.item.code_number = vm.originalItem.code_number;
        } else if (productCategory.coding_type === 'automatic') {
          vm.item.code =
            productCategory.coding_prefix + productCategory.nextProductCodeNumberToAssign;
          vm.item.code_number = productCategory.nextProductCodeNumberToAssign;
        }
      }
    }

    function openProductCategoriesModal() {
      var successCallback = function () {
        getProductCategories('update');
      };

      ProductCategoryService.openProductCategoriesModal(successCallback);
    }

    // ----- TRANSPORTATION ----- //

    function getTransportations() {
      var params = {
        get: 'all',
        // transportationId: vm.item.id,
        skip_check_role: true,
      };

      vm.loadingTransportations = true;
      TransportationService.getTransportations(params).then(function (data) {
        // vm.transportations = data.items;

        vm.transportations = [];

        data.items.forEach(function (item, index) {
          item.prev = data.items[index - 1];
          item.next = data.items[index + 1];

          vm.transportations.push(item);
        });

        if (!vm.createMode) {
          vm.productSelected = angular.copy(vm.item); // To keep diferent scope as we modify .prev / .next

          const productFound = vm.transportations.find((product) => product.id === vm.item.id);

          vm.productSelected.prev = productFound.prev;
          vm.productSelected.next = productFound.next;

          vm.productSearchId = vm.item.id;
        }

        // Related products
        vm.relatedTransportations = vm.transportations.filter((product) => {
          return product.id !== vm.item.id;
        });

        vm.loadingTransportations = false;
      });
    }

    vm.selectProduct = function (product) {
      if (vm.productSelected && vm.productSelected.id === product.id) {
        return;
      }

      $location.path(`/transportation/${product.id}`);
    };

    vm.goToOtherProduct = function (otherProductId) {
      let product = vm.UtilService.findItemInArray(vm.transportations, 'id', otherProductId);

      vm.selectProduct(product);
    };

    function openTransportationContentsModal() {
      TransportationContentService.openTransportationContentsModal(vm.item);
    }

    // ----- LOCATIONS ----- //

    function getLocations() {
      if (vm.locations) {
        return;
      }

      var params = {
        get: 'active',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingLocations = true;
      locationService.getLocations(params).subscribe((response) => {
        vm.locations = locationService.groupLocations(response); // , '', 'locations'
        vm.loadingLocations = false;
      });
    }

    function openLocationsModal() {
      var successCallback = function () {
        vm.locations = null;
        getLocations();
      };

      locationModalService.openLocationsModal(successCallback);
    }

    /*function compareUniquenessOfLocations(model, type, form) {
            if (type === 'arrival' && vm.item.departure_location_id) {
                form.arrival_location_id.$setValidity('unique', model !== vm.item.departure_location_id);
            }
            else if (type === 'departure' && vm.item.arrival_location_id) {
                form.departure_location_id.$setValidity('unique', model !== vm.item.arrival_location_id);
            }
        }*/

    // ----- TRANSPORTATION SCHEDULES ----- //

    function setTransportationSchedules(transportation_schedules) {
      //why? api better
      if (vm.item.transportation_schedules.length === 0) {
        addTransportationSchedule();
      }

      var orderBy = $filter('orderBy');
      vm.item.transportation_schedules = orderBy(
        vm.item.transportation_schedules,
        'departure',
        false
      );

      vm.transportationSchedulesOriginal = angular.copy(vm.item.transportation_schedules);
    }

    function addTransportationSchedule() {
      var schedule = {
        createMode: true,
        departure: vm.UtilService.setDurationTime(),
        is_always_available: true,
        status: vm.activeStatus,
      };

      vm.item.transportation_schedules.push(schedule);
    }

    function removeTransportationSchedule(index) {
      vm.item.transportation_schedules.splice(index, 1);
    }

    function changeTransportationScheduleStatus(schedule) {
      TransportationScheduleService.changeTransportationScheduleStatus(vm.item.id, schedule);
    }

    function deleteTransportationSchedule(schedule, index) {
      var successCallback = function (index) {
        removeTransportationSchedule(index);
      };

      TransportationScheduleService.deleteTransportationSchedule(
        vm.item.id,
        schedule,
        successCallback,
        index
      );
    }

    function validateUniqueSchedules() {
      vm.schedulesDuplicated = false;
      var sorted, i, isDuplicate;
      sorted = vm.item.transportation_schedules.concat().sort(function (a, b) {
        a.dep = $filter('date')(a.departure, 'HH:mm');
        b.dep = $filter('date')(b.departure, 'HH:mm');

        if (a.dep > b.dep) {
          return 1;
        }
        if (a.dep < b.dep) {
          return -1;
        }
        return 0;
      });

      for (i = 0; i < vm.item.transportation_schedules.length; i++) {
        sorted[i].isDuplicate =
          (sorted[i - 1] && sorted[i - 1].dep === sorted[i].dep) ||
          (sorted[i + 1] && sorted[i + 1].dep === sorted[i].dep);
        if (sorted[i].isDuplicate) {
          vm.schedulesDuplicated = true;
        }
      }
    }

    function setScheduleType(type) {
      if (vm.scheduleTypeOriginal !== type) {
        vm.item.transportation_schedules = [];
        addTransportationSchedule();
      } else {
        vm.item.transportation_schedules = vm.transportationSchedulesOriginal;
      }
    }

    function toggleEditMode(item) {
      // Toggle
      item.editMode = !item.editMode;

      // if item is not in edit mode anymore
      if (!item.editMode) {
        // Undo changes
        _restoreServerValues(item);
      } else {
        // save server name to restore it if the user cancel edition
        item.serverValues = angular.toJson(item);

        item.departure = vm.UtilService.setDurationTime(item.departure);
      }
    }

    // Restore item server values - Edit mode
    function _restoreServerValues(item) {
      var serverItem = angular.fromJson(item.serverValues);

      transportationScheduleFieldsDefinition.forEach(function (field) {
        item[field] = serverItem[field];
      });
    }

    // ----- Route points----- //
    function addRoutePoint() {
      vm.item.transportation_route_points.push({
        createMode: true,
        stop_on_route: false,
      });

      validateUniqueRoutePoints();
    }

    function removeRoutePoint(index) {
      vm.item.transportation_route_points.splice(index, 1);
      /*if (vm.item.transportation_route_points.length === 0){
                vm.showRoutePointsMap = false;
            }*/
      validateUniqueRoutePoints();
    }

    function restoreRoutePoints() {
      vm.item.transportation_route_points = angular.copy(vm.origDataTransportationRoutePoints);
      validateUniqueRoutePoints();
    }

    // Avoid duplicate prepayment ranges
    function validateUniqueRoutePoints() {
      vm.routePointsDuplicated = false;

      var routePoints = vm.item.transportation_route_points;
      if (routePoints.length > 1) {
        for (var i = 0; i < routePoints.length; ++i) {
          for (var j = 0; j < routePoints.length; ++j) {
            if (
              i !== j &&
              routePoints[i].location &&
              routePoints[j].location &&
              routePoints[i].location.id === routePoints[j].location.id
            ) {
              vm.routePointsDuplicated = true;
              return false;
            }
          }
        }
        return true;
      }
    }

    function openTransportationRoutePointsMapModal() {
      var item = {
        departure: {
          name: vm.item.departure_location.name,
          lat: vm.item.departure_location.geo_lat,
          lng: vm.item.departure_location.geo_lng,
        },
        arrival: {
          name: vm.item.arrival_location.name,
          lat: vm.item.arrival_location.geo_lat,
          lng: vm.item.arrival_location.geo_lng,
        },
        waypoints: null,
      };

      if (vm.item.transportation_route_points.length) {
        var points = [];
        vm.item.transportation_route_points.forEach(function (route) {
          if (route.location) {
            points.push({
              description: route.description,
              stop_on_route: route.stop_on_route,
              location: {
                name: route.location.name,
                lat: route.location.geo_lat,
                lng: route.location.geo_lng,
              },
            });
          }
        });

        item.waypoints = points;
      }

      TransportationService.openTransportationRoutePointsMapModal(item);
    }

    function setRoutePointMap() {
      //vm.showRoutePointsMap = true;
      validateUniqueRoutePoints();
    }

    // ----- FACILITIES ----- //

    function getFacilities() {
      var params = {
        get: 'transportation',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      facilityService.getFacilities(params).subscribe((response) => {
        vm.facilities = response;
      });
    }

    function openFacilitiesModal() {
      const successCallback = () => {
        getFacilities();
      };

      facilityModalService.openFacilitiesModal(successCallback);
    }

    function setCheckedFacilities(facility_ids) {
      facility_ids.forEach((key) => {
        vm.checkedFacility[key] = true;
      });
    }

    // ----- WHAT TO BRING ----- //

    function getWhatToBrings() {
      var params = {
        get: 'transportation',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      whatToBringService.getWhatToBrings(params).subscribe((response) => {
        vm.whatToBrings = response;
      });
    }

    function openWhatToBringsModal() {
      const successCallback = () => {
        getWhatToBrings();
      };

      whatToBringModalService.openWhatToBringsModal(successCallback);
    }

    function setCheckedWhatToBring(what_to_bring_ids) {
      what_to_bring_ids.forEach(function (key) {
        vm.checkedWhatToBring[key] = true;
      });
    }

    // Remove values from object
    function removeValuesFromTransportationSchedules() {
      vm.item.transportation_schedules.forEach(function (item) {
        //item.editMode  = false;
        item.departure = $filter('date')(item.departure, 'HH:mm');

        //delete item.editMode;
        delete item.dep;
        delete item.isDuplicate;
        delete item.$$hashKey;
        delete item.serverValues;
      });
    }

    function removeValuesFromTransportationRoutePoints() {
      vm.item.transportation_route_points.forEach(function (item, index) {
        if (item.location.geo_lat === '' || item.location.geo_lng === '') {
          removeRoutePoint(index);
        } else {
          item.location_id = item.location.id;
          delete item.$$hashKey; // not working
          //delete item.location;  // perfomance ui-select issues
        }
      });
    }

    // Create/Update
    function saveTransportation(isFormValid) {
      vm.formErrors = false;

      validateUniqueSchedules();
      validateUniqueRoutePoints();

      if (
        !isFormValid ||
        vm.productCategories.length === 0 ||
        vm.locations === 0 ||
        vm.routePointsDuplicated ||
        vm.schedulesDuplicated
        // || (vm.atvCrEnabled && !vm.item.cabys_description)
      ) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      if (
        vm.editMode &&
        !vm.item.service_items_cost_based &&
        vm.item.associated_service_items.length > 0
      ) {
        var params = {
          mode: 'danger',
          title: 'UPDATE_COST_TYPE',
          body: 'UPDATE_COST_TYPE_WARNING',
        };

        var successCallback = function () {
          vm.item.associated_service_items = [];
          saveTransportationApi();
        };

        var cancelCallback = function () {
          cancelEdit();
        };

        // Just in case the users want to modify the cost type with associated service items
        ModalWindowConfirmService.open(params, successCallback, cancelCallback);
      } else {
        saveTransportationApi();
      }
    }

    function saveTransportationApi() {
      removeValuesFromTransportationSchedules();
      removeValuesFromTransportationRoutePoints();

      vm.item.facility_ids = utilService.parseItemIds(vm.checkedFacility);
      vm.item.what_to_bring_ids = utilService.parseItemIds(vm.checkedWhatToBring);

      vm.sendingForm = true;
      TransportationService.saveTransportation(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: response });
          } else {
            vm.item = response;
            setItemOptions(response);

            vm.measurementUnit = vm.measurementUnits.find(
              (item) => item.id === response.measurement_unit_id
            );

            getServerData(response);

            vm.flashMessage = vm.UtilService._clearFlashMessage();
            vm.UtilService.scrollToTop();
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;

          if (vm.item.schedule_type === 'fixed') {
            vm.item.transportation_schedules.forEach(function (schedule) {
              schedule.departure = vm.UtilService.setDurationTime(schedule.departure);
            });
          }

          vm.UtilService.scrollToTop();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onCanceledItem({ item: vm.item });
    }

    // ----- ASSOCIATED PROVIDERS ----- //

    function selectAssociatedProviders() {
      vm.showAssociatedProviders = true;
    }

    function onAssociatedProviderSaved(product, items) {
      vm.item.default_provider_id = product.default_provider_id;

      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onAssociatedProviderDeleted(items) {
      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onSelectedTab(tab) {
      vm.active = tab;
    }

    // ----- ASSOCIATED SERVICE ITEMS ----- //

    function selectAssociatedServiceItems() {
      vm.showAssociatedServiceItems = true;
    }

    function onAssociatedServiceItemSaved(items) {
      vm.item.associated_service_items = items;
      vm.originalItem.associated_service_items = items;
    }

    function onAssociatedServiceItemDeleted(items) {
      vm.item.associated_service_items = items;
      vm.originalItem.associated_service_items = items;
    }

    // ----- ACCOUNTING -----
    function selectAccounting() {
      vm.showAccounting = true;
    }

    // ----- COSTS AND PRICES -----

    function selectCostsAndPrices() {
      vm.showCostsAndPrices = false;

      setTimeout(() => {
        vm.showCostsAndPrices = true;
      }, 100); // hack

      // vm.showCostsAndPrices = true;
    }

    function onCostsAndPricesSaved(associated_providers) {
      vm.item.associated_providers = associated_providers;
      vm.originalItem.associated_providers = associated_providers;
    }

    // ----- ASSOCIATED TAXES -----

    function selectAssociatedTaxes(reload) {
      if (vm.taxes && !reload) {
        return;
      }

      let productCategoryAssociatedTaxes = {
        purchases: [],
        sales: [],
      };

      if (vm.item.product_category.associated_taxes) {
        vm.item.product_category.associated_taxes.map((associated_tax) => {
          if (associated_tax.scope_type === 'purchases') {
            productCategoryAssociatedTaxes.purchases.push(associated_tax);
          } else {
            productCategoryAssociatedTaxes.sales.push(associated_tax);
          }
        });
      }

      vm.taxes = TaxService.setAssociatedTaxes(
        productCategoryAssociatedTaxes,
        vm.item.associated_taxes,
        vm.taxTypes
      );
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    function onAssociatedTaxesSaved(product) {
      if (!vm.customTaxConfiguration) {
        delete product.exonerations;
      }

      vm.item = product;
      vm.originalItem = angular.copy(vm.item);
      // vm.taxesOriginal = angular.copy(vm.taxes);

      selectAssociatedTaxes(true);
    }

    function onAssociatedTaxesCanceled() {
      vm.customTaxConfiguration = vm.originalItem.custom_tax_configuration;

      vm.taxes = vm.taxesOriginal;
      vm.taxesOriginal = angular.copy(vm.taxes);
    }
  }
})();
